"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultMileage = exports.getDefaultDurationMonths = void 0;
const leasing_1 = require("./leasing");
const enums_1 = require("../../enums");
const loan_1 = require("./loan");
const getDefaultDurationMonths = (financingType) => financingType === enums_1.FinancingType.LEASING ? leasing_1.defaultLeasingInput.durationMonths : loan_1.defaultLoanInput.durationMonths;
exports.getDefaultDurationMonths = getDefaultDurationMonths;
const getDefaultMileage = (financingType) => financingType === enums_1.FinancingType.LEASING ? leasing_1.defaultLeasingInput.mileage : 0;
exports.getDefaultMileage = getDefaultMileage;
//# sourceMappingURL=utils.js.map